/**
 * Thumbnail Processing Service
 * Uses the dedicated wardrobe-thumbnail webhook to convert user-uploaded
 * clothing photos into flat-lay product style thumbnails.
 */

import { isPluggableApiAvailable, pluggableApiService } from './pluggableApiService';

/**
 * Process an uploaded item image into a flat-lay style thumbnail.
 * Returns the processed CDN URL, or null if processing failed/unavailable.
 */
export async function processItemThumbnail(cdnUrl: string): Promise<string | null> {
  if (!isPluggableApiAvailable()) {
    return null;
  }

  const result = await pluggableApiService.processThumbnail({
    imageUrl: cdnUrl,
  });

  if (result.success && result.imageUrl) {
    return result.imageUrl;
  }

  throw new Error(result.error ?? 'Thumbnail processing failed');
}
